import React from "react";

import { Icons } from "../../data/Assets";

import { ITreeItem, IOrganizationForTree } from "../../interfaces/tree";

import { getElipsisString, getFormattedString } from "../../helpers/utility";

import { SVGIcon } from "../wrappers/SVGIcon";

export const TreeItem = (item: ITreeItem) => {
    const { type, level, name, method, parentMethod, onClickItem, children, selected, expanded, lastLevel, data, parentId } = item;

    return (
        <div className='immployer_admin__tree__item'>
            <button
                className={`btn_block immployer_admin__tree__item__btn immployer_admin__tree__item__btn__lvl_${level + 1} ${expanded ? 'immployer_admin__tree__item__btn__expanded' : ''} ${selected ? 'immployer_admin__tree__item__btn__selected' : ''}`}
                onClick={() => onClickItem(item)}
            >
                <SVGIcon src={level === lastLevel ? Icons.PointFill : Icons.TriangleFill} color="primary" />
                {(type === 'organization' && level === 0) &&
                    <span className={`immployer_admin__tib__status_pill immployer_admin__tib__status_pill__${(data as IOrganizationForTree).status}`}>
                        {getFormattedString((data as IOrganizationForTree).status, 'title_case')}
                    </span>
                }
                <span>{parentMethod ? `[${parentMethod.toUpperCase()}] ` : ''}{getElipsisString(name, 35)}</span>
            </button>
            {children.length > 0 && expanded &&
                <div className="immployer_admin__tree__item__children">
                    {children.map((child, idx) =>
                        <TreeItem
                            type={type}
                            key={idx}
                            id={child.id}
                            parentId={parentId}
                            level={level + 1}
                            name={child.name}
                            method={child.method}
                            parentMethod={method}
                            onClickItem={onClickItem}
                            children={child.children}
                            data={child.data}
                            selected={child.selected}
                            expanded={child.expanded}
                            lastLevel={lastLevel}
                        />
                    )}
                </div>
            }
        </div>
    );
};